<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-body">
                <div class="d-flex flex-column">
                    <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                        <b-col lg="3">
                            <p>Records Totali: {{ rows }}</p>
                        </b-col>

                        <b-col lg="9">
                            <b-pagination :total-rows="rows" v-model="currentPage" :per-page="perPage" align="right" size="sm"> </b-pagination>
                        </b-col>
                    </b-row>
                </div>
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            {{ (currentPage - 1) * perPage + row.index + 1 }}
                        </template>
                        <template #cell(meseRichiesta)="{ item }">
                            {{ formatDateTimeCustom(item.meseRichiesta, "MMMM yyyy") }}
                            <!-- {{ formatDateTime(item.meseRiferimento) }} -->
                        </template>
                        <template #cell(statoAttualeDataOra)="{ item }">
                            {{ formatDateTime(item.statoAttualeDataOra) }}
                        </template>
                        <!--   <template #cell(actions)="{ item }">
                            <b-container class="bv-example-row">
                                <b-button size="sm" v-b-tooltip.hover title="Visualizza Dettaglio" variant="outline-secondary" @click="onClickView(item)">
                                    <i class="bi bi-eye"></i>
                                </b-button>
                            </b-container>
                        </template> -->
                    </b-table>
                </div>
            </div>
            <div class="d-flex flex-column">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Records Totali: {{ rows }}</p>
                    </b-col>

                    <b-col lg="9">
                        <b-pagination :total-rows="rows" v-model="currentPage" :per-page="perPage" align="right" size="sm"> </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
        <flussi-modal-view-component ref="cmpFlussiModalView"></flussi-modal-view-component>
    </div>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
import FlussiModalViewComponent from "./FlussiModalViewComponent.vue";
export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    mixins: [UtilityMixin],
    components: { FlussiModalViewComponent },
    data() {
        return {
            pathResource: "/flussifatturaanticipata",
            items: [],
            rows: 0,
            perPage: 50,
            currentPage: 1,
            filtro: {},
            listKey: 0,
            fields: [
                {
                    label: "*",
                    key: "index",
                },
                // {
                //     label: "Presidio",
                //     key: "presidio",
                // },
                // {
                //     label: "Regime",
                //     key: "descrizioneRegime",
                // },
                // {
                //     label: "Flusso",
                //     key: "codiceFlusso",
                // },
                {
                    label: "Mese Riferimento",
                    key: "meseRichiesta",
                },
                {
                    label: "Stato Attuale",
                    key: "statoAttuale",
                },
                {
                    label: "Data/Ora",
                    key: "statoAttualeDataOra",
                },
                {
                    label: "",
                    class: "sa-table-column-action-double",
                    key: "actions",
                },
            ],
        };
    },
    mounted() {
        // let me = this;
    },
    watch: {
        currentPage() {
            this.loadData();
        },
    },
    methods: {
        init() {
            let me = this;
            me.loadData();
        },
        loadData() {
            let me = this;
            me.openShowModalLoading();

            me.items = [];
            me.loadDataResources(me.pathResource, me.filtro, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.closeShowModalLoading();
            me.rows = response.data.data.recordsNumber;
            me.listKey++;
        },
        loadDataError(response) {
            let me = this;
            me.closeShowModalLoading();
            me.$emit("afterLoadData", response);
            me.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
    },
};
</script>

<style></style>
